module.exports = {
    "profileMenu": {
        "link": "\/account\/profile",
        "linkLabel": "Profile",
        "linkIndex": 0,
        "subMenu": [
            {
                "name": "contact",
                "link": "\/account\/profile\/contact",
                "linkLabel": "Contact Info"
            },
            {
                "name": "subscription",
                "link": "\/account\/profile\/subscription",
                "linkLabel": "XD+"
            },
            {
                "name": "security",
                "link": "\/account\/profile\/security",
                "linkLabel": "Security"
            },
            {
                "name": "headshots",
                "link": "\/account\/profile\/headshots",
                "linkLabel": "Manage Headshots"
            },
            {
                "name": "logos",
                "link": "\/account\/profile\/logos",
                "linkLabel": "Manage Logos"
            },
            {
                "name": "social",
                "link": "\/account\/profile\/social",
                "linkLabel": "Social Media"
            }
        ],
        "icon": "faUser"
    },
    "programDefaultsDropdownMenu": {
        "link": "\/account\/program-defaults",
        "linkLabel": "Program Defaults",
        "linkIndex": 1,
        "dropdownItems": [
            {
                "link": "\/account\/program-defaults\/scheduled-campaigns",
                "linkLabel": "TEST link Name 123 Preferences",
                "icon": "faCog",
                "configPath": "scheduledCampaignsMenu"
            }
        ],
        "icon": "faCog"
    },
    "ordersMenu": {
        "link": "\/account\/orders",
        "linkLabel": "Orders",
        "linkIndex": 1,
        "subMenu": [
            {
                "name": "pending",
                "link": "\/account\/orders\/pending",
                "linkLabel": "Pending Orders"
            },
            {
                "name": "history",
                "link": "\/account\/orders\/history",
                "linkLabel": "Order History"
            },
            {
                "name": "scheduled",
                "link": "\/account\/orders\/scheduled",
                "linkLabel": "Scheduled Orders"
            }
        ],
        "icon": "faFolderOpen"
    },
    "walletMenu": {
        "link": "\/account\/wallet",
        "linkLabel": "Wallet",
        "linkIndex": 2,
        "subMenu": [
            {
                "name": "credit-cards",
                "link": "\/account\/wallet\/credit-cards",
                "linkLabel": "Credit Cards"
            },
            {
                "name": "vouchers",
                "link": "\/account\/wallet\/vouchers",
                "linkLabel": "Vouchers"
            },
            {
                "name": "ad-budget",
                "link": "\/account\/wallet\/ad-budget",
                "linkLabel": "Ad Budget"
            }
        ],
        "icon": "faWallet"
    },
    "addressBookMenu": {
        "link": "\/account\/address-book",
        "linkLabel": "Address Book",
        "linkIndex": 3,
        "subMenu": [
            {
                "name": "shipping",
                "link": "\/account\/address-book\/shipping",
                "linkLabel": "Shipping Addresses"
            },
            {
                "name": "mailing",
                "link": "\/account\/address-book\/address-lists",
                "linkLabel": "Address Lists"
            },
            {
                "name": "assets",
                "link": "\/account\/address-book\/mailing-assets",
                "linkLabel": "Mailing Assets"
            }
        ],
        "icon": "faAddressBook"
    }
};

